// TODO remove after implementing Stripe v3

import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';
// import { UserServiceProvider } from '@services/user/user.service';

@Pipe({
	name: 'profilePriceFilter'
})
export class ProfilePriceFilterPipe implements PipeTransform {
	user: any;

	constructor(
		private decimalPipe: DecimalPipe // private userService: UserServiceProvider
	) {}

	transform(input: number, type: string) {
		let output;

		if (!input && input !== 0) {
			return '';
		}

		const inputRound = this.decimalPipe.transform(input, '.2-2');
		const money = inputRound.toString().split('.');
		// this.user = this.userService.userData;
		const subscriptionObj = this.user.subscriptionPrice;

		switch (type) {
			case 'bill':
				let symbol;
				symbol = subscriptionObj.currencySymbol || '$';
				output = symbol + money[0];
				break;

			case 'coin':
				output = `.${money[1]}` || '00';
				break;

			case 'coin-no-zero':
				if (money[1] === '00') {
					output = '';
				} else {
					output = `.${money[1]}`;
				}
				break;

			case 'label':
				let label = subscriptionObj.currencyName || 'USD';

				if (label === 'AUD' || label === 'NZD') {
					label = 'AUD';
				}

				output = label;
				break;

			case 'full-currency-symbol':
				const symbolFull = subscriptionObj.currencySymbol || '$';
				let labelFull = subscriptionObj.currencyName || 'USD';

				if (labelFull === 'AUD' || labelFull === 'NZD') {
					labelFull = 'AUD';
				}

				output = labelFull + symbolFull + inputRound;
				break;

			case 'discount':
				const discountSymbol = subscriptionObj.currencySymbol || '$';

				if (subscriptionObj.discount.percent) {
					output = `${money[0]}%`;
				} else {
					output = discountSymbol + money;
				}
				break;

			default:
				output = '';
		}

		return output;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=xqsfzqb50j!./shared/pipes/profile-price-filter/profile-price-filter.ts